import React, { useState } from 'react';
import { Container, Row, Col, Card, Table, Badge, Form, Button, InputGroup, Modal, Pagination } from 'react-bootstrap';
import { Search, Filter, Download, Eye,Calendar, DollarSign, Gift} from 'lucide-react';
import '../../../../assets/css/admin/dashboardCSS/Donations.css';
import Adminlayout from '../../../../layouts/admin/Adminlayout';
import TitleBar from '../../../../subscreens/admin/TitleBar';

const Donations = () => {
  // State Management
  const [searchQuery, setSearchQuery] = useState('');
  const [filterType, setFilterType] = useState('All');
  const [filterDate, setFilterDate] = useState('All Time');
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedDonation, setSelectedDonation] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  

  // Donations Data
  const [donations] = useState([
    {
      id: '1',
      donorName: 'Ayaan Ahmad',
      donorEmail: 'ayaanahmad@example.com',
      donorPhone: '0300-1234567',
      studentName: 'Ali khan',
      studentId: 'ST-101',
      type: 'Fee',
      amount: 20000,
      item: null,
      date: '21-Jan-2026',
      status: 'Completed',
      paymentMethod: 'Bank Transfer',
      transactionId: 'TXN-20250812-001'
    },
    {
      id: '2',
      donorName: 'Sania khan',
      donorEmail: 'saniakhan@example.com',
      donorPhone: '0301-9876543',
      studentName: 'Sara Ahmad',
      studentId: 'ST-104',
      type: 'Books',
      amount: null,
      item: '5 Books',
      date: '22-Jan-2026',
      status: 'Completed',
      paymentMethod: 'In-Kind',
      transactionId: 'TXN-20250815-002'
    },
    {
      id: '3',
      donorName: 'Faizan Malik',
      donorEmail: 'faizanmalik@example.com',
      donorPhone: '0302-5551234',
      studentName: 'Ahmed Raza',
      studentId: 'ST-103',
      type: 'Uniform',
      amount: 5000,
      item: null,
      date: '23-Jan-2026',
      status: 'Completed',
      paymentMethod: 'Cash',
      transactionId: 'TXN-20250818-003'
    },
    {
      id: '4',
      donorName: 'Ayaan Ahmad',
      donorEmail: 'ayaanahmad@example.com',
      donorPhone: '0303-7778888',
      studentName: 'Sara Khan',
      studentId: 'ST-102',
      type: 'Fee',
      amount: 25000,
      item: null,
      date: '24-Jan-2026',
      status: 'Pending',
      paymentMethod: 'Online',
      transactionId: 'TXN-20250820-004'
    },
    // {
    //   id: 'DON-105',
    //   donorName: 'Bilal Mahmood',
    //   donorEmail: 'bilal@example.com',
    //   donorPhone: '0304-4445555',
    //   studentName: 'Hassan Malik',
    //   studentId: 'ST-105',
    //   type: 'Books',
    //   amount: null,
    //   item: '3 Books + Stationery',
    //   date: '2025-08-22',
    //   status: 'Completed',
    //   paymentMethod: 'In-Kind',
    //   transactionId: 'TXN-20250822-005'
    // },
    // {
    //   id: 'DON-106',
    //   donorName: 'Zainab Hussain',
    //   donorEmail: 'zainab@example.com',
    //   donorPhone: '0305-1112222',
    //   studentName: 'Ali Ahmed',
    //   studentId: 'ST-101',
    //   type: 'Fee',
    //   amount: 15000,
    //   item: null,
    //   date: '2025-08-25',
    //   status: 'Completed',
    //   paymentMethod: 'Bank Transfer',
    //   transactionId: 'TXN-20250825-006'
    // }
  ]);

  // Stats
  const stats = {
    totalDonations: donations.length,
    totalAmount: donations.reduce((sum, d) => sum + (d.amount || 0), 0),
    cashDonations: donations.filter(d => d.amount !== null).length,
    inKindDonations: donations.filter(d => d.item !== null).length
  };

  // Filter Donations
  const filteredDonations = donations.filter(donation => {
    const matchesSearch = 
      donation.donorName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      donation.studentName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      donation.id.toLowerCase().includes(searchQuery.toLowerCase());
    
    const matchesType = filterType === 'All' || donation.type === filterType;
    const matchesDate = filterDate === 'All Time';
    
    return matchesSearch && matchesType && matchesDate;
  });

  
  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentDonations = filteredDonations(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredDonations.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  // Handle View Details
  const handleViewDetails = (donation) => {
    setSelectedDonation(donation);
    setShowDetailModal(true);
  };

  // Handle Export
  const handleExport = () => {
    console.log('Exporting donations data...');
    alert('CSV export started!');
  };

  // Get Status Badge
  const getStatusBadge = (status) => {
    return status === 'Completed' ? 'success' : 'warning';
  };

  // Get Type Badge Color
  const getTypeBadgeColor = (type) => {
    const colors = {
      'Fee': 'primary',
      'Books': 'info',
      'Uniform': 'warning',
      'Other': 'secondary'
    };
    return colors[type] || 'secondary';
  };

  return (
    <Adminlayout>
    <div className="dn-donations-page">
      <Container fluid>
          <TitleBar
        title="All Donations"
        subtitle="Track and manage all donations received"
      ></TitleBar>
        {/* Page Header - NGO Style */}
        {/* <div className="dn-donations-header">
          <div>
            <h2 className="dn-donations-title">All Donations</h2>
            <p className="dn-donations-subtitle">Track and manage all donations received</p>
          </div>
       
        </div> */}

        {/* Stats Cards */}
        <Row className="dn-donations-stats-row mb-4">
          <Col lg={3} md={6} className="mb-3">
            <Card className="dn-donation-stat-card">
              <Card.Body>
                <div className="dn-stat-content-donation">
                  <div className="dn-stat-info-donation">
                    <h4 className="dn-stat-value-donation">{stats.totalDonations}</h4>
                    <p className="dn-stat-title-donation">Total Donations</p>
                  </div>
                  <div className="dn-stat-icon-wrapper-donation dn-total-donations-icon">
                    <Gift size={24} />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={6} className="mb-3">
            <Card className="dn-donation-stat-card">
              <Card.Body>
                <div className="dn-stat-content-donation">
                  <div className="dn-stat-info-donation">
                    <h4 className="dn-stat-value-donation">PKR {stats.totalAmount.toLocaleString()}</h4>
                    <p className="dn-stat-title-donation">Total Amount</p>
                  </div>
                  <div className="dn-stat-icon-wrapper-donation dn-total-amount-icon">
                    <DollarSign size={24} />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={6} className="mb-3">
            <Card className="dn-donation-stat-card">
              <Card.Body>
                <div className="dn-stat-content-donation">
                  <div className="dn-stat-info-donation">
                    <h4 className="dn-stat-value-donation">{stats.cashDonations}</h4>
                    <p className="dn-stat-title-donation">Cash Donations</p>
                  </div>
                  <div className="dn-stat-icon-wrapper-donation dn-cash-donations-icon">
                    <DollarSign size={24} />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={6} className="mb-3">
            <Card className="dn-donation-stat-card">
              <Card.Body>
                <div className="dn-stat-content-donation">
                  <div className="dn-stat-info-donation">
                    <h4 className="dn-stat-value-donation">{stats.inKindDonations}</h4>
                    <p className="dn-stat-title-donation">In-Kind Donations</p>
                  </div>
                  <div className="dn-stat-icon-wrapper-donation dn-inkind-donations-icon">
                    <Gift size={24} />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Search and Filter Section */}
        <Card className="dn-filter-card-donations mb-4">
          <Card.Body>
            <Row className="align-items-center">
              <Col lg={4} md={6} className="mb-3 mb-lg-0">
                <InputGroup>
                  <InputGroup.Text className="dn-search-icon-donations">
                    <Search size={18} />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search by donor, student, or ID..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="dn-search-input-donations"
                  />
                </InputGroup>
              </Col>

              <Col lg={2} md={3} className="mb-3 mb-lg-0">
                <InputGroup>
                  <InputGroup.Text className="dn-filter-icon-donations">
                    <Filter size={18} />
                  </InputGroup.Text>
                  <Form.Select
                    value={filterType}
                    onChange={(e) => setFilterType(e.target.value)}
                    className="dn-filter-select-donations"
                  >
                    <option value="All">All Types</option>
                    <option value="Fee">Fee</option>
                    <option value="Books">Books</option>
                    <option value="Uniform">Uniform</option>
                    <option value="Other">Other</option>
                  </Form.Select>
                </InputGroup>
              </Col>

              <Col lg={3} md={3} className="mb-3 mb-lg-0">
                <InputGroup>
                  <InputGroup.Text className="dn-calendar-icon-donations">
                    <Calendar size={18} />
                  </InputGroup.Text>
                  <Form.Select
                    value={filterDate}
                    onChange={(e) => setFilterDate(e.target.value)}
                    className="dn-filter-select-donations"
                  >
                    <option value="All Time">All Time</option>
                    <option value="This Month">This Month</option>
                    <option value="Last Month">Last Month</option>
                    <option value="Last 3 Months">Last 3 Months</option>
                  </Form.Select>
                </InputGroup>
              </Col>

              <Col lg={3} md={12}>
                <Button className="dn-export-donations-btn" onClick={handleExport}>
                  <Download size={18} />
                  Export CSV
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Donations Table */}
        <Card className="dn-donations-table-card">
          <Card.Body>
            <div className="dn-table-responsive table-responsive">
              <Table hover className="dn-donations-table">
                <thead>
                  <tr>
                    <th>Donation ID</th>
                    <th>Donor</th>
                    <th>Student</th>
                    <th>Type</th>
                    <th>Amount / Item</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredDonations.length > 0 ? (
                    filteredDonations.map((donation) => (
                      <tr key={donation.id}>
                        <td className="dn-donation-id">{donation.id}</td>
                        <td className="dn-donor-name">{donation.donorName}</td>
                        <td className="dn-student-name-donations">{donation.studentName}</td>
                        <td>
                          <Badge bg={getTypeBadgeColor(donation.type)} className="dn-type-badge-donations">
                            {donation.type}
                          </Badge>
                        </td>
                        <td className="dn-amount-item-cell">
                          {donation.amount 
                            ? `PKR ${donation.amount.toLocaleString()}` 
                            : donation.item}
                        </td>
                        <td>{new Date(donation.date).toLocaleDateString('en-GB')}</td>
                        <td>
                          <Badge bg={getStatusBadge(donation.status)} className="dn-table-status-badge">
                            {donation.status}
                          </Badge>
                        </td>
                        <td>
                          <button
                            className="dn-action-btn-donations dn-view-btn-donations"
                            onClick={() => handleViewDetails(donation)}
                            title="View Details"
                          >
                            <Eye size={16} />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        <p className="dn-no-data-donations">No donations found</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

               {/* Pagination */}
            {filteredDonations.length > 0 && (
              <div className="dnpagination-wrapper">
                <Pagination className="dn-pagination">
                  <Pagination.First 
                    onClick={() => paginate(1)} 
                    disabled={currentPage === 1}
                  />
                  <Pagination.Prev 
                    onClick={() => paginate(currentPage - 1)} 
                    disabled={currentPage === 1}
                  />
                  
                  {[...Array(totalPages)].map((_, index) => (
                    <Pagination.Item
                      key={index + 1}
                      active={index + 1 === currentPage}
                      onClick={() => paginate(index + 1)}
                    >
                      {index + 1}
                    </Pagination.Item>
                  ))}

                  <Pagination.Next 
                    onClick={() => paginate(currentPage + 1)} 
                    disabled={currentPage === totalPages}
                  />
                  <Pagination.Last 
                    onClick={() => paginate(totalPages)} 
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>

      {/* Donation Detail Modal */}
      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} size="lg" centered>
        <Modal.Header closeButton className="dn-modal-header-donations">
          <Modal.Title>Donation Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedDonation && (
            <div className="dn-donation-details-modal">
              <Row>
                <Col md={12} className="mb-3">
                  <div className="dn-detail-section-header">
                    <h5>Donation Information</h5>
                  </div>
                </Col>
                <Col md={6} className="mb-3">
                  <p className="dn-detail-label-donations">Donation ID</p>
                  <p className="dn-detail-value-donations">{selectedDonation.id}</p>
                </Col>
                <Col md={6} className="mb-3">
                  <p className="dn-detail-label-donations">Date</p>
                  <p className="dn-detail-value-donations">{new Date(selectedDonation.date).toLocaleDateString('en-GB')}</p>
                </Col>
                <Col md={6} className="mb-3">
                  <p className="dn-detail-label-donations">Type</p>
                  <div>
                    <Badge bg={getTypeBadgeColor(selectedDonation.type)} className="dn-detail-badge">
                      {selectedDonation.type}
                    </Badge>
                  </div>
                </Col>
                <Col md={6} className="mb-3">
                  <p className="dn-detail-label-donations">Status</p>
                  <div>
                    <Badge bg={getStatusBadge(selectedDonation.status)} className="dn-detail-badge">
                      {selectedDonation.status}
                    </Badge>
                  </div>
                </Col>

                <Col md={12} className="mb-3 mt-3">
                  <div className="dn-detail-section-header">
                    <h5>Donor Information</h5>
                  </div>
                </Col>
                <Col md={6} className="mb-3">
                  <p className="dn-detail-label-donations">Donor Name</p>
                  <p className="dn-detail-value-donations">{selectedDonation.donorName}</p>
                </Col>
                <Col md={6} className="mb-3">
                  <p className="dn-detail-label-donations">Email</p>
                  <p className="dn-detail-value-donations">{selectedDonation.donorEmail}</p>
                </Col>
                <Col md={6} className="mb-3">
                  <p className="dn-detail-label-donations">Phone</p>
                  <p className="dn-detail-value-donations">{selectedDonation.donorPhone}</p>
                </Col>

                <Col md={12} className="mb-3 mt-3">
                  <div className="dn-detail-section-header">
                    <h5>Student Information</h5>
                  </div>
                </Col>
                <Col md={6} className="mb-3">
                  <p className="dn-detail-label-donations">Student Name</p>
                  <p className="dn-detail-value-donations">{selectedDonation.studentName}</p>
                </Col>
                <Col md={6} className="mb-3">
                  <p className="dn-detail-label-donations">Student ID</p>
                  <p className="dn-detail-value-donations">{selectedDonation.studentId}</p>
                </Col>

                <Col md={12} className="mb-3 mt-3">
                  <div className="dn-detail-section-header">
                    <h5>Payment Details</h5>
                  </div>
                </Col>
                <Col md={6} className="mb-3">
                  <p className="dn-detail-label-donations">Payment Method</p>
                  <p className="dn-detail-value-donations">{selectedDonation.paymentMethod}</p>
                </Col>
                <Col md={6} className="mb-3">
                  <p className="dn-detail-label-donations">Transaction ID</p>
                  <p className="dn-detail-value-donations">{selectedDonation.transactionId}</p>
                </Col>
                <Col md={12} className="mb-3">
                  <p className="dn-detail-label-donations">Amount / Item</p>
                  <p className="dn-detail-value-donations dn-amount-highlight">
                    {selectedDonation.amount 
                      ? `PKR ${selectedDonation.amount.toLocaleString()}` 
                      : selectedDonation.item}
                  </p>
                </Col>
              </Row>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
    </Adminlayout>
  );
};

export default Donations;